import { ReactNode } from "react"
import styled, { css } from "styled-components"
import { getColor } from "utils"
interface ISortOptionsProps {
    children?: ReactNode,
    sortBy?: string
    onMouseLeave?: (e?:any) => void,
}

const StyledSortOptions = styled.div`
    flex-flow: column nowrap;
    .sort-by-option-container{
        width: 100%;
        p{margin: 0; font-size: 14px}
        justify-content: start;
        padding: 6px 8px;
        &.default-container{
            background-color: ${({sortBy}:ISortOptionsProps)=> sortBy ? '#e9eef3' :'none'};
            color: ${getColor('brand')};
            :hover{
                background-color: #e9eef3
            }
        }
        :hover{
            background-color: rgb(239,237,246);
        }
        :active{
            background-color: #e9eef3;
            color: ${getColor('brandDarkHight')}
        }
    }
`

export const SortingOptions = ({children,...props}:ISortOptionsProps) => {
    return (<StyledSortOptions {...props}>
            {children}
        </StyledSortOptions>)
}

export default SortingOptions